
import { mapState } from "vuex";
import emptyTileImage from "~/assets/images/emptyTileImage.svg";

export default {
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      emptyTileImage
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadGridFilters"]),
    getName() {
      switch (this.id) {
        case "add-photos":
          return "Image";
        case "set-addons":
          return "Add-on";
        case "add-description":
          return "Description";
        case "set-choices":
          return "Choice";
        default:
          return "";
      }
    },
    displayMessage() {
      if (this.menuUploadGridFilters.displayWith) {
        return `No items with the ${this.getName}`;
      } else if (this.menuUploadGridFilters.displayWithout) {
        return `No items without the ${this.getName}`;
      } else {
        return `No ${this.getName()} available.`;
      }
    }
  }
};
